import PropTypes from 'prop-types';
import React from 'react';
import ClearAllButton from '../ClearAllButton/ClearAllButton';
import SearchChoiceButton from '../SearchChoiceButton/SearchChoiceButton';
import buttonGroupStyles from './SearchDefaultView.module.scss';

export default function SearchDefaultButtonGroup({
  clearAllButtonHandler = () => {},
  dataType,
  eventHandler,
  groupId,
  hasClearAllButton = false,
  headingLabel,
  options,
}) {
  return (
    <div
      key={dataType}
      className={buttonGroupStyles.buttonGroupContainer}
      data-testid="auto-suggest-button-group-menu-wrapper"
      id={groupId}
    >
      <div className={buttonGroupStyles.buttonGroupHeadingContainer}>
        <h2 className="h3">{headingLabel}</h2>
        {hasClearAllButton ? (<ClearAllButton onClick={clearAllButtonHandler} />) : null}
      </div>
      <div className={buttonGroupStyles.searchChoiceButtonContainer} data-testid={`${dataType.replace(/\s/g, '-')}-button-group`}>
        {options?.map((option) => (
          <SearchChoiceButton
            key={option.key}
            dataType={dataType}
            eventHandler={eventHandler}
            option={option}
          />
        ))}
      </div>
    </div>
  );
}

SearchDefaultButtonGroup.propTypes = {
  dataType: PropTypes.string.isRequired,
  headingLabel: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ),
  hasClearAllButton: PropTypes.bool,
  clearAllButtonHandler: PropTypes.func,
  eventHandler: PropTypes.func.isRequired,
  groupId: PropTypes.string,
};
